<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>環境品質監測報告</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <div class="sectTitle">歷年監測報告</div>
        <div class="reportCont">
          <div class="report">
            <a target="_blank" :href="getLink(115-i)" :key="i" v-for="i in 14"><i class="fa-brands fa-envira"></i> {{115-i}} 年度環境品質監測年度報告</a>
          </div>
          <div class="pic"></div>
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';
import { Util, ImgContainerAutoResize } from '../../util/util';

export default defineComponent({
  name: 'EnvironmentReport',
  components: {
    Header,
    Footer
  },
  data() {
    return {
    }
  },
  methods: {
    getLink: function(year: string) {      
      if(Util.WEB_ENVIRONMENT === "DEV") {
        return `./report/environment/${year}年度環境品質監測年度報告書.pdf`;
      } else {
        return `https://media.taiwancement.com/web_hppc/report/environment/${year}年度環境品質監測年度報告書.pdf`;
      }
    },
  },
  mounted() {
    Util.chkWebEnv();
    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
  }
});
</script>

<style>
#app-environment-report {
}

.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/environmentReport/kv.webp");
  background-position: center 75%;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 .sectTitle {
  margin: 0 0 20px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 32px;
}

.sect1 .reportCont {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  box-sizing: border-box;
  font-weight: bold;
  /* background: #e0e0e0; */
}

.sect1 .reportCont .report {
  flex: 0 0 60%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  /* background: #e0e0e0; */
}

.sect1 .reportCont .report a {
  flex: 0 0 48%;
  margin: 0 0 20px;
  padding: 20px;
  box-sizing: border-box;
  display: inline-block;
  border: solid 1px #00884466;
  border-radius: 5px;
  text-align: center;
  font-size: 18px;
  color: #008844;
  background: #00884408;
}

.sect1 .reportCont .report a:hover {
  background: #00884420;
}

.sect1 .reportCont .report a i {
  font-size: 20px;
}

.sect1 .reportCont .pic {
  flex: 0 0 35%;
  height: 495px;
  border-radius: 5px;
  background: url("./../../assets/environmentReport/pic.jpg") center;
  background-size: cover;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect1 .reportCont .report a {
    flex: 0 0 100%;
    padding: 15px;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect1 .sectTitle {
    font-size: 24px;
  }

  .sect1 .reportCont .report  {
    flex: 0 0 100%;
  }

  .sect1 .reportCont .report a {
    flex: 0 0 100%;
    padding: 15px;
  }

  .sect1 .reportCont .pic {
    flex: 0 0 100%;
  }
}
</style>
